// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SWIWY","item":"styles_item__i1oaj","label":"styles_label__qdp8I"};